(function () {
  "use strict";

  function init() {
    /* Guard: only run once even if called multiple times */
    if (window.__cpgInit) return;
    window.__cpgInit = true;

    var isDrawerOpen = false;

    /* Drawer refs — looked up after DOM ready so they always exist */
    function getDrawer() {
      return document.getElementById("cpg-size-drawer");
    }
    function getOverlay() {
      return document.getElementById("cpg-size-overlay");
    }
    function getDrawerBody() {
      return document.getElementById("cpg-drawer-body");
    }
    function getCloseBtn() {
      return document.getElementById("cpg-drawer-close");
    }

    /* ---- Swatch click: swap image + update color name ---- */
    document.addEventListener("click", function (e) {
      var swatch = e.target.closest(".cpg-swatch");
      if (!swatch) return;
      var card = swatch.closest(".cpg-card");
      if (!card) return;

      card.querySelectorAll(".cpg-swatch").forEach(function (s) {
        s.classList.remove("is-active");
      });
      swatch.classList.add("is-active");

      var colorNameEl = card.querySelector(".cpg-card__color-name");
      if (colorNameEl)
        colorNameEl.textContent = swatch.getAttribute("data-color");

      var mainImg = card.querySelector(".cpg-card__main-img");
      var newSrc = swatch.getAttribute("data-main-img");
      if (mainImg && newSrc && mainImg.src.indexOf(newSrc) === -1) {
        /* Preload new image first — swap only when fully loaded to avoid flicker */
        var preload = new Image();
        preload.onload = function () {
          mainImg.classList.add("cpg-img--fade");
          requestAnimationFrame(function () {
            mainImg.src = newSrc;
            mainImg.classList.remove("cpg-img--fade");
          });
        };
        preload.onerror = function () {
          /* Fallback: swap anyway if preload fails */
          mainImg.src = newSrc;
        };
        preload.src = newSrc;
      }

      // Update ATC button based on swatch availability
      var atcBtn = card.querySelector(".cpg-card__atc");
      if (atcBtn) {
        if (swatch.getAttribute("data-available") === "true") {
          atcBtn.disabled = false;
          atcBtn.textContent = "Add it now";
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = "Sold Out";
        }
      }
    });

    /* ---- ATC click: open size drawer ---- */
    document.addEventListener("click", function (e) {
      var atcBtn = e.target.closest(".cpg-card__atc");
      if (!atcBtn || atcBtn.disabled) return;
      var card = atcBtn.closest(".cpg-card");
      if (!card) return;

      var activeSwatch =
        card.querySelector(".cpg-swatch.is-active") ||
        card.querySelector(".cpg-swatch");
      if (!activeSwatch) return;

      var variants = [];
      try {
        variants = JSON.parse(activeSwatch.getAttribute("data-color-variants"));
      } catch (err) {
        console.warn("CPG: Could not parse variants", err);
        return;
      }

      renderSizePills(variants);
      var sizeChartData = card.getAttribute("data-size-chart");
      if (sizeChartData) {
        var drawerBody = getDrawerBody();

        // Parse the chart data to get the subheading
        var subheading = "";
        try {
          var parsed = JSON.parse(sizeChartData);
          if (parsed && parsed.length > 0) {
            // Use the first chart's subheading (or combine multiple if you want)
            subheading = parsed[0].subheading || "";
          }
        } catch (err) {
          console.warn("Could not parse size chart data", err);
        }

        // Remove any old size chart elements first (avoid duplicates if drawer reopens)
        var existingLink = drawerBody.parentNode.querySelector(
          ".cpg-drawer-size-chart-link"
        );
        if (existingLink) existingLink.remove();
        var existingSub = drawerBody.parentNode.querySelector(
          ".cpg-drawer-size-chart-subheading"
        );
        if (existingSub) existingSub.remove();

        // Create subheading element (if there is one)
        if (subheading) {
          var subEl = document.createElement("p");
          subEl.className = "cpg-drawer-size-chart-subheading";
          subEl.textContent = subheading;
          subEl.style.cssText =
            "text-align:left;margin:0 0 8px;font-size:13px;color:#444;font-family:'Sequel_Sans_Medium_Head';    padding: 10px 22px 0px;";
          drawerBody.parentNode.insertBefore(subEl, drawerBody);
        }

        // Create the link
        var link = document.createElement("a");
        link.href = "#";
        link.className = "cpg-drawer-size-chart-link";
        link.setAttribute("data-size-chart", sizeChartData);
        link.innerHTML = "Size Chart";
        link.style.cssText =
          "display:block;text-align:left;margin-bottom:0px;padding-bottom:10px;padding-top:10px;padding-bottom:10px;    padding-left: 22px;border-bottom:1px solid #e5e5e5;font-size:13px;text-decoration:underline;color:inherit;cursor:pointer;";
        drawerBody.parentNode.insertBefore(link, drawerBody);
      }

      openDrawer();
    });

    /* ---- Render size pills ---- */
    function renderSizePills(variants) {
      var drawerBody = getDrawerBody();
      if (!drawerBody) return;

      drawerBody.innerHTML = "";
      drawerBody.classList.remove("is-loading");
      drawerBody.classList.remove("is-gendered");

      if (!variants || variants.length === 0) {
        drawerBody.innerHTML =
          '<p style="text-align:center;color:#999;">No sizes available.</p>';
        return;
      }

      // Check if any variant has a gender field
      var isGendered = variants.some(function (v) {
        return v.gender;
      });

      if (isGendered) {
        drawerBody.classList.add("is-gendered");

        // Group variants by gender
        var groups = {};
        variants.forEach(function (v) {
          var g = v.gender || "Other";
          if (!groups[g]) groups[g] = [];
          groups[g].push(v);
        });

        // Force order: Adult first, Youth second
        var order = ["Adult", "Youth"];
        Object.keys(groups).forEach(function (g) {
          if (order.indexOf(g) === -1) order.push(g);
        });

        order.forEach(function (gender) {
          if (!groups[gender]) return;

          var column = document.createElement("div");
          column.className = "cpg-gender-column";

          var heading = document.createElement("h4");
          heading.className = "cpg-gender-heading";
          heading.textContent = gender;
          column.appendChild(heading);

          groups[gender].forEach(function (v) {
            column.appendChild(buildSizePill(v));
          });

          drawerBody.appendChild(column);
        });
      } else {
        // Original flat list
        variants.forEach(function (v) {
          drawerBody.appendChild(buildSizePill(v));
        });
      }
    }

    function buildSizePill(variant) {
      var pill = document.createElement("button");
      pill.className = "cpg-size-pill";
      pill.textContent =
        (variant.size || "One Size") + (!variant.available ? " " : "");
      pill.setAttribute("data-variant-id", variant.id);

      if (!variant.available) {
        pill.classList.add("is-soldout");
        pill.disabled = true;
        pill.setAttribute(
          "aria-label",
          (variant.size || "One Size") + " - Sold Out"
        );
      } else {
        pill.setAttribute("aria-label", variant.size || "One Size");
        pill.addEventListener("click", function () {
          addToCart(variant.id);
        });
      }

      return pill;
    }

    /* ---- AJAX add to cart ---- */
    function addToCart(variantId) {
      var drawerBody = getDrawerBody();
      if (!drawerBody) return;

      var originalHTML = drawerBody.innerHTML;
      drawerBody.classList.add("is-loading");
      drawerBody.innerHTML = "";

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Cart add failed: " + res.status);
          return res.json();
        })
        .then(function () {
          closeDrawer();
          openFlexCartDrawer();
        })
        .catch(function (err) {
          console.error("CPG: Add to cart error", err);
          drawerBody.classList.remove("is-loading");
          drawerBody.innerHTML = originalHTML;
          alert(
            "Sorry, there was an issue adding this item. Please try again."
          );
        });
    }

    /* ---- Open Flex cart drawer ---- */
    function openFlexCartDrawer() {
      document.dispatchEvent(new CustomEvent("theme:cart:open"));
      if (
        window.theme &&
        window.theme.cart &&
        typeof window.theme.cart.open === "function"
      ) {
        window.theme.cart.open();
        return;
      }
      fetch("/cart.js")
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent("theme:cart:update", { detail: { cart: cart } })
          );
        });
    }

    /* ---- Drawer open/close ---- */
    function openDrawer() {
      var drawer = getDrawer();
      var overlay = getOverlay();
      if (!drawer || !overlay) return;

      drawer.classList.add("is-open");
      overlay.classList.add("is-open");
      overlay.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      isDrawerOpen = true;

      setTimeout(function () {
        var firstPill = drawer.querySelector(".cpg-size-pill:not(:disabled)");
        if (firstPill) firstPill.focus();
      }, 350);
    }

    function closeDrawer() {
      var drawer = getDrawer();
      var overlay = getOverlay();
      if (!drawer || !overlay) return;

      drawer.classList.remove("is-open");
      overlay.classList.remove("is-open");
      overlay.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      isDrawerOpen = false;
    }

    /* Drawer close listeners — use event delegation so they work
       even if the drawer is rendered after this script runs */
    document.addEventListener("click", function (e) {
      if (e.target && e.target.id === "cpg-size-overlay") closeDrawer();
      if (e.target && e.target.id === "cpg-drawer-close") closeDrawer();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isDrawerOpen) closeDrawer();
    });

    /* ---- Flickity init per section, lazy via IntersectionObserver ---- */
    function initSectionSliders(sectionEl) {
      if (typeof Flickity === "undefined") return;

      var slider = sectionEl.querySelector(".cpg-slider");
      if (slider && !slider.flickityInstance) {
        if (slider.classList.contains("flickity-enabled")) {
          try {
            Flickity.data(slider).destroy();
          } catch (e) {}
        }
        var opts = {};
        try {
          opts = JSON.parse(slider.getAttribute("data-flickity") || "{}");
        } catch (e) {}
        slider.flickityInstance = new Flickity(slider, opts);

        requestAnimationFrame(function () {
          var totalCellWidth = 0;
          slider.querySelectorAll(".cpg-card").forEach(function (cell) {
            totalCellWidth += cell.offsetWidth;
          });
          var btns = slider.querySelectorAll(".flickity-prev-next-button");
          if (totalCellWidth <= slider.offsetWidth) {
            btns.forEach(function (btn) {
              btn.style.display = "none";
            });
          } else {
            btns.forEach(function (btn) {
              btn.style.display = "";
            });
          }
        });
        /* Prevent swatch swipes from triggering the main product slider.
           Strategy: on pointerdown/touchstart inside a swatch wrap, temporarily
           set draggable=false on the main Flickity instance, then re-enable it
           on pointerup/touchend. This is the most reliable approach because it
           works at the Flickity options level before any drag detection happens. */
        var flkty = slider.flickityInstance;

        slider.addEventListener(
          "pointerdown",
          function (e) {
            if (e.target.closest(".cpg-swatches-wrap")) {
              flkty.options.draggable = false;
              flkty.isDraggable = false;
            }
          },
          true
        ); /* useCapture=true to intercept before Flickity sees it */

        slider.addEventListener(
          "touchstart",
          function (e) {
            if (e.target.closest(".cpg-swatches-wrap")) {
              flkty.options.draggable = false;
              flkty.isDraggable = false;
            }
          },
          { passive: true, capture: true }
        );

        /* Re-enable dragging once the interaction ends */
        ["pointerup", "pointercancel", "touchend", "touchcancel"].forEach(
          function (evt) {
            window.addEventListener(
              evt,
              function () {
                flkty.options.draggable = true;
                flkty.isDraggable = true;
              },
              { passive: true }
            );
          }
        );
      }

      sectionEl
        .querySelectorAll(".cpg-swatches[data-flickity]")
        .forEach(function (el) {
          if (el.flickityInstance) return;
          if (el.classList.contains("flickity-enabled")) {
            try {
              Flickity.data(el).destroy();
            } catch (e) {}
          }
          el.flickityInstance = new Flickity(el, {
            cellAlign: "left",
            contain: true,
            pageDots: false,
            prevNextButtons: true,
            freeScroll: false,
            groupCells: false,
          });

          requestAnimationFrame(function () {
            var totalCellWidth = 0;
            el.querySelectorAll(".cpg-swatch").forEach(function (cell) {
              totalCellWidth += cell.offsetWidth;
            });
            var btns = el.querySelectorAll(".flickity-prev-next-button");
            if (totalCellWidth <= el.offsetWidth) {
              btns.forEach(function (btn) {
                btn.style.display = "none";
              });
            } else {
              btns.forEach(function (btn) {
                btn.style.display = "";
              });
            }
          });
        });
    }

    function initWithRetry(sectionEl, attempts) {
      attempts = attempts || 0;
      if (typeof Flickity !== "undefined") {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            initSectionSliders(sectionEl);
          });
        });
      } else if (attempts < 15) {
        setTimeout(function () {
          initWithRetry(sectionEl, attempts + 1);
        }, 200);
      }
    }

    function observeSection(sectionEl) {
      var inited = false;
      function run() {
        if (inited) return;
        inited = true;
        initWithRetry(sectionEl);
      }
      if ("IntersectionObserver" in window) {
        var obs = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                run();
                obs.disconnect();
              }
            });
          },
          { rootMargin: "200px 0px", threshold: 0 }
        );
        obs.observe(sectionEl);
      } else {
        if (document.readyState === "complete") {
          run();
        } else {
          window.addEventListener("load", run);
        }
      }
    }

    /* Observe all section instances currently on the page */
    document
      .querySelectorAll('[id^="custom-product-grid-"]')
      .forEach(observeSection);

    /* Theme editor: re-init on section reload */
    document.addEventListener("shopify:section:load", function (e) {
      var sectionEl = document.getElementById(
        "custom-product-grid-" + e.detail.sectionId
      );
      if (!sectionEl) return;
      /* Reset guard so fresh section gets observed */
      window.__cpgInit = false;
      setTimeout(function () {
        init();
      }, 200);
    });
  } /* end init() */

  /* ============================================================
     BOOT — run init once DOM is ready
  ============================================================ */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
